import { alertActionsType } from '../actions';

export function alert(state = {}, action) {
  switch (action.type) {
    case alertActionsType.SUCCESS:
      return {
        type: 'alert-success',
        message: action.message
      };
    case alertActionsType.ERROR:
      return {
        type: 'alert-danger',
        message: action.message
      };
    case alertActionsType.CLEAR:
      return {};
    default:
      return state
  }
}